interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-3xl ${isCenter ? "mx-auto text-center" : ""}`}>
      <div
        className={`flex items-center gap-3 ${isCenter ? "justify-center" : ""}`}
      >
        <span className="w-8 h-px bg-primary-500" />
        <span className="font-label text-xs md:text-sm tracking-[0.25em] uppercase text-primary-600">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      ) : null}
    </div>
  );
}